import { AfterViewInit, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Admin } from 'src/app/models/admin/admin.model';
import { Login } from 'src/app/models/login.model';
import { AdminService } from 'src/app/services/admin.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AddUserComponent } from './dialogs/add-user/add-user.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements AfterViewInit {

  displayedColumns: string[] = ['userId', 'firstName', 'lastName', 'email', 'accessLevel', 'accessId', 'status', 'action'];
  filteredValues = {
    userId: '', firstName: '', lastName: '', email: '', accessLevel: '', accessId: '', status: '', action: ''
  };
  users: Admin[] = [];
  dataSource: MatTableDataSource<Admin> = new MatTableDataSource(this.users);
  pageEvent: PageEvent = {
    pageIndex: 0,
    pageSize: 10,
    length: 100
  };
  manualPage: number;
  pageIndex: number = 0;
  goTo:number;

  pageNumbers: number[] = [];
  noOfPages: number = 0;
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  loggedInUser = new Login("", "", "", "", "", "", 0, false, false, false, "", false);

  userIdFilter = new FormControl();
  firstNameFilter = new FormControl();
  lastNameFilter = new FormControl();
  emailFilter = new FormControl();
  accessIdFilter = new FormControl();
  accessLevelFilter = new FormControl();
  statusFilter = new FormControl();
  showMsg: boolean = false;
  selectedPageNumber : number = 1;
  currenttotalPages:number = 0;
  customPageSizeOptions : number []= [500, 100];

  isLoadingUsers: boolean = true;

  constructor(private adminService: AdminService, private cdref: ChangeDetectorRef, private authService: AuthenticationService, private matDialog: MatDialog) {
    this.authService.setLogin.subscribe(loginData => {
      this.loggedInUser = loginData;

    });
  }
  ngOnInit() {
    this.getExistingUsers();
  }
  clear() {
    this.userIdFilter.setValue("");
    this.firstNameFilter.setValue("");
    this.lastNameFilter.setValue("");
    this.emailFilter.setValue("");
    this.accessIdFilter.setValue("");
    this.accessLevelFilter.setValue("");
    this.statusFilter.setValue("");
    this.showMsg = false;

  }

  getExistingUsers() {
    this.isLoadingUsers = true;
    this.users = [];
    this.adminService.getExistingUsers(this.loggedInUser.accessId).subscribe({
      next: (result: any) => {
        this.users = result;

        this.dataSource = new MatTableDataSource(this.users);
        this.dataSource.paginator = this.paginator;

        this.cdref.detectChanges();
        this.setPageNumbers();
        this.filterData();
        this.updateGoto();

        if (this.users.length == 0) {
          this.showMsg = true;
        }
      },
      error: (err: any) => {
        console.log(err);
        this.isLoadingUsers = false;
      },
      complete: () => {
        console.log('complete');
        this.isLoadingUsers = false;
      }
    });
  }


  UpdateManualPage(index: number): void {
    this.manualPage = index;
    this.pageEvent.pageIndex = index;
    this.pageIndex = index;
    this.paginator.pageIndex = index;
    this.paginator.page.next({
      pageIndex: index,
      pageSize: 10,
      length: this.users.length
    });
  }

  filterData() {
    this.userIdFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['userId'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });

    this.firstNameFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['firstName'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });

    this.lastNameFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['lastName'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });

    this.emailFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['email'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });

    this.accessIdFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['accessId'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });

    this.accessLevelFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['accessLevel'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });

    this.statusFilter.valueChanges.subscribe((filterValue) => {
      this.filteredValues['status'] = filterValue;
      this.dataSource.filter = JSON.stringify(this.filteredValues);
      this.dataSource.paginator = this.paginator;
      this.cdref.detectChanges();
      this.paginator.firstPage();
      this.setPageNumbers();
    });
    this.dataSource.filterPredicate = this.customFilterPredicate();

  }

  customFilterPredicate() {
    const myFilterPredicate = (data: Admin, filter: string): boolean => {

      let searchString = JSON.parse(filter);
      return data.userID.toString().trim().toLowerCase().indexOf(searchString.userId.toLowerCase()) !== -1 &&
        data.firstName.toString().toLocaleLowerCase().trim().indexOf(searchString.firstName.toLocaleLowerCase()) !== -1 &&
        data.lastName.toString().toLocaleLowerCase().trim().indexOf(searchString.lastName.toLocaleLowerCase()) !== -1 &&
        data.email.toString().toLocaleLowerCase().trim().indexOf(searchString.email.toLocaleLowerCase()) !== -1 &&
        data.accessID.toString().toLocaleLowerCase().trim().indexOf(searchString.accessId.toString().toLocaleLowerCase()) !== -1 &&
        data.accessLevel.toString().toLocaleLowerCase().trim().indexOf(searchString.accessLevel.toLocaleLowerCase()) !== -1 &&
        data.status.toString().toLocaleLowerCase().trim().indexOf(searchString.status.toLocaleLowerCase()) !== -1;
    }
    return myFilterPredicate;
  }

  OpenAddUserDialog() {
    const successDialog = this.matDialog.open(AddUserComponent, {
      data: { element: new Admin("", "", "", "", 0, "", true, 0, ""), type: 'Add' }
    });

    successDialog.afterClosed().subscribe(value => {
      if (value != null) {
        this.users.unshift(value);
        this.dataSource = new MatTableDataSource(this.users);
        this.dataSource.paginator = this.paginator;
        this.cdref.detectChanges();
        this.filterData();
      }
    });
  }

  OpenEditUserDialog(element: Admin) {

    this.matDialog.open(AddUserComponent, {
      data: { element: element, type: 'Edit' }
    }).afterClosed().subscribe(value => {
      if (value != null) {
        let user = this.users.find(x => x.userID == value.userID);
        if (user != null) {
          user.firstName = value.firstName;
          user.lastName = value.lastName;
          user.email = value.email;
          user.userID = value.userID;
          user.accessID = value.accessID;
          user.accessLevelID = value.accessLevelID;
          user.accessLevel = value.accessLevel;
          user.status = value.status;
          user.accessName = value.accessName;
        }
      }
    });
  }
  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.users);
    this.dataSource.paginator = this.paginator;
}

updateGoToPage() {

    this.paginator.pageIndex = this.goTo - 1;
  }

  goToChange() {
    this.paginator.pageIndex = this.goTo - 1;
    const event: PageEvent = {
      length: this.paginator.length,
      pageIndex: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize
    };
    this.paginator.page.next(event);
  }

  updateGoto() {
    this.goTo = (this.pageIndex || 0) + 1;
    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.paginator.length/ this.paginator.pageSize); i++) {
      this.pageNumbers.push(i);
    }
  }
  onPaginateChange(event:any){
    this.selectedPageNumber = event.pageIndex +1;
    this.goTo = this.selectedPageNumber;
    this.setPageNumbers();
  }

  setPageNumbers(){

    this.pageNumbers = [];
    for (let i = 1; i <= Math.ceil(this.paginator.length/ this.paginator.pageSize); i++) {
      this.pageNumbers.push(i);
    }
    this.goTo = this.paginator.pageIndex + 1;
    this.selectedPageNumber = this.paginator.pageIndex + 1;

    this.currenttotalPages = this.pageNumbers.length;


  }


  // getRangeLabel(page: number, pageSize: number, length: number): string {
  //   if (length === 0) {
  //     return $localize`Page 1 of 1`;
  //   }
  //   const amountPages = Math.ceil(length / pageSize);
  //   return $localize`Page ${page + 1} of ${amountPages}`;
  // }
}
